import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
  Container,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import { getMantIndks } from "../../../redux/descriptorsProfiles/mantIndik/actions";
import {
  getIndikators,
  saveIndikator,
  editIndikator,
  deleteIndikator,
} from "../../../redux/descriptorsProfiles/indikators/actions";
import { getMeasurementUnit } from "../../../redux/descriptorsProfiles/MeasurementUnit/actions";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";

const schema = Yup.object().shape({
  indicador: Yup.number().required("**Campo requerido"),
  unidad_medida: Yup.number().required("**Campo requerido"),
  meta: Yup.string().ensure().required("**Campo requerido"),
  fuente_verificacion: Yup.string().ensure().required("**Campo requerido"),
  // descriptor: Yup.number().required('**Campo requerido'),
  // unidad_medida: Yup.number().required('**Campo requerido'),
  // meta: Yup.string().ensure().required("**Campo requerido"),
  // objetivo: Yup.string().ensure().required("**Campo requerido"),
  // formula_calculo: Yup.string().ensure().required("**Campo requerido"),
});

const Indkator = (props) => {
  //* States
  const [showFormModal, setShowFormModal] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [filter, setFilter] = useState("");
  const [editItem, setEditItem] = useState({});
  const [validated, setValidated] = useState(false);
  const [mantIndkator, setMantIndkator] = useState(null);
  const [unitMeasu, setUnitMeasu] = useState(null);
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "indicador_nombre",
    desc: "Nombre",
  });
  //* Redux
  const { loaderMantIndks, mantIndks, mantIndksFail } = useSelector(
    (store) => store.mantIndk
  );
  const { loading, measurementUnits, measurementUnitError } = useSelector(
    (store) => store.measurementUnit
  );
  const {
    loaderIndikators,
    indikators,
    indikatorsFaild,
    formIndikatorFaild,
    saveLoaderIndikator,
  } = useSelector((store) => store.indikators);

  //* variables
  const dispatch = useDispatch();
  const userRoles = useSelector((store) => store.auth.userRoles);

  const pages = Math.ceil((indikators ? indikators.count : 0) / limit);
  const columns = [
    {
      id: "nombre",
      Header: "Nombre",
      Cell: (value) => value.row.original.list_indicador[0].nombre,
    },
    {
      id: "objetivo",
      Header: "Objetivo",
      Cell: (value) => value.row.original.list_indicador[0].objetivo,
    },
    {
      id: "formula_calculo",
      Header: "Fórmula de cálculo",
      Cell: (value) => value.row.original.list_indicador[0].formula_calculo,
    },
    {
      Header: "Meta",
      accessor: "meta",
    },
    {
      Header: "Fuente de verificación",
      accessor: "fuente_verificacion",
    },
    {
      id: "fecha_creacion",
      Header: "Fecha de creación",
      Filter: "",
      Cell: (value) =>
        moment(value.row.original.fecha_creacion).format("DD/MM/YYYY"),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) =>
      props.match.params.miDescriptor ? null : (
          <div className="btn-group" role="group">
            <Button
              size="sm"
              variant="link"
              type="button"
              onClick={() => onEdit(value.row.original, value.row.index)}
            >
              <i className="material-icons">edit</i>
            </Button>
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              onClick={() => onDelete(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          </div>
        ),
    },
  ];
  const filters = [
    { id: "indicador_nombre", desc: "Nombre" },
    { id: "objetivo", desc: "Objetivo" },
  ];
  //* Method
  const _getIndikators = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getIndikators({
        offset: offs,
        limit: lim,
        tipo_busqueda: "descriptor_id",
        filter: props.match.params.id,
        tipo_busqueda_2: tipoBusqueda.id,
        filter_2: filt,
      })
    );

  useEffect(() => {
    _getIndikators();
    dispatch(getMeasurementUnit());
    dispatch(getMantIndks());
  }, []);

  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
    setMantIndkator(null);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
    handleChangeMantIndk(item.list_indicador[0].id);
    //handleUnitMeas(item.list_unidad_medida[0].id);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getIndikators(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = (req) => {
    req.descriptor = props.match.params.id;
    if (!edit) {
      dispatch(saveIndikator(req, setShowFormModal));
    } else {
      req.id = editItem.id;
      dispatch(editIndikator(req, index, setShowFormModal));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getIndikators(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteIndikator(id, index));
    }
  };

  const handleChangeMantIndk = (idIndk) => {
    const _mantIndks = mantIndks.data.slice();
    const indikatorItem = _mantIndks.find(
      (indk) => indk.id === parseInt(idIndk)
    );
    setMantIndkator(indikatorItem);
  };

  const handleUnitMeas = (idUnitMeas) => {
    const _measurementUnits = measurementUnits.slice();
    const unitMeasuItem = _measurementUnits.find(
      (unitMeas) => unitMeas.id === parseInt(idUnitMeas)
    );
    setUnitMeasu(unitMeasuItem);
  };

  return (
    <div className="mt-5">
      <Container>
        <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
          <h5 className="text-black-50 m-0">Indicadores</h5>
          <Form onSubmit={onSearch}>
            <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
              <Col>
                <h6>
                  <b>Busqueda por: {tipoBusqueda.desc}</b>
                </h6>
              </Col>
              <Col xs="auto">
                <Form.Control
                  name="filter"
                  type="search"
                  placeholder="Buscar"
                  className="rounded-pill form-control-sm"
                ></Form.Control>
              </Col>
              <Col xs="auto">
                <ButtonGroup>
                  <Button
                    variant="light"
                    size="sm"
                    className="rounded-pill mr-1"
                    onClick={() => seeAll()}
                  >
                    <i className="material-icons">list</i>
                  </Button>
                  { props.match.params.miDescriptor ? null : (
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  )}
                  <OverlayTrigger
                    placement="auto"
                    overlay={<Tooltip {...props}>Seleccionar Filtrado</Tooltip>}
                  >
                    <Dropdown className="ml-3 mr-3">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filters.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </OverlayTrigger>
                </ButtonGroup>
              </Col>
            </Form.Row>
          </Form>
        </div>
        {mantIndksFail && (
          <Alert variant="danger" className="my-4">
            {mantIndksFail}
          </Alert>
        )}
        {loaderIndikators ? (
          <div className="d-flex justify-content-center mt-4">
            <Spinner
              animation="border"
              role="status"
              className="d-flex justify-content-center"
            />
          </div>
        ) : indikators && indikators.data.length > 0 ? (
          <>
            <Card className="border-0">
              <Card.Body className="px-1 px-sm-2">
                <div className="mx-1 border-left border-warning">
                  <Alert variant="light">
                    <p>
                      Los primeros 3 indicadores se tomarán en cuenta para la
                      evaluación del desempeño por factores.
                    </p>
                  </Alert>
                </div>
                <CustomTable columns={columns} data={indikators.data} />
              </Card.Body>
            </Card>
            <CustomPagint
              limit={limit}
              setLimit={setLimit}
              offset={offset}
              setOffset={setOffset}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              dataLenght={indikators.count}
              pages={pages}
              pagFunc={_getIndikators}
            />
          </>
        ) : (
          <Alert variant="info" className="my-4">
            Sin registros que mostrar.
          </Alert>
        )}
      </Container>
      <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            //nombre: edit ? editItem.nombre : '',
            //objetivo: edit ? editItem.objetivo : '',
            //formula_calculo: edit ? editItem.formula_calculo : ''
            indicador: edit ? editItem.indicador : "",
            unidad_medida: edit ? editItem.unidad_medida : "",
            meta: edit ? editItem.meta : "",
            fuente_verificacion: edit ? editItem.fuente_verificacion : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            values,
            touched,
            //isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="ft-modal-title">
                  {edit ? "editar indicador" : "Agregar indicador"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {formIndikatorFaild &&
                typeof formIndikatorFaild !== "object" ? (
                  <Alert variant="danger" className="mt-2 mb-3">
                    {formIndikatorFaild}
                  </Alert>
                ) : null}
                {measurementUnitError && (
                  <Alert variant="danger" className="my-4">
                    {measurementUnitError}
                  </Alert>
                )}
                {indikatorsFaild && (
                  <Alert variant="danger" className="my-4">
                    {indikatorsFaild}
                  </Alert>
                )}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Indicador
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={loaderMantIndks ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          name="indicador"
                          className="rounded-pill"
                          disabled={edit && loaderMantIndks}
                          required
                          value={values.indicador}
                          isInvalid={touched.indicador && !!errors.indicador}
                          onChange={(e) => {
                            setFieldValue("indicador", e.target.value);
                            handleChangeMantIndk(e.target.value);
                          }}
                        >
                          <option value="" disabled selected>
                            Indicador
                          </option>
                          {mantIndks
                            ? mantIndks.data.map((item, index) => (
                                <option
                                  key={index + 1}
                                  value={item.id ? item.id : ""}
                                >
                                  {item.nombre ? item.nombre.toUpperCase() : ""}
                                </option>
                              ))
                            : null}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.indicador}
                        </Form.Control.Feedback>
                        {formIndikatorFaild &&
                        typeof formIndikatorFaild === "object" &&
                        formIndikatorFaild.indicador ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {formIndikatorFaild.indicador.map((item) => (
                              <li>{item}</li>
                            ))}
                          </ul>
                        ) : null}
                      </Col>
                      {loaderMantIndks && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Nombre
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      name="nombre"
                      className="rounded-pill"
                      required
                      readOnly
                      type="text"
                      value={mantIndkator ? mantIndkator.nombre : null}
                      placeholder="Nombre"
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Objetivo
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      readOnly
                      as="textarea"
                      value={mantIndkator ? mantIndkator.objetivo : null}
                      placeholder="Objetivo"
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Fórmula de cálculo
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      name="formula_calculo"
                      className="rounded-pill"
                      required
                      readOnly
                      type="text"
                      value={mantIndkator ? mantIndkator.formula_calculo : null}
                      placeholder="Fórmula de cálculo"
                    />
                  </Col>
                </Form.Group>
                {/*<Form.Group as={Row}>
              <Form.Label column sm={3}>Fórmula de cálculo</Form.Label>
              <Col sm={9}>
                <Form.Control
                  name="formula_calculo"
                  className="rounded-pill"
                  required
                  readOnly
                  type="text"
                  defaultValue={mantIndkator ? mantIndkator.formula_calculo : null}
                  placeholder="Fórmula de cálculo" />
              </Col>
            </Form.Group> */}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Meta
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      name="meta"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.meta}
                      placeholder="Meta"
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.meta && !!errors.meta}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.meta}
                    </Form.Control.Feedback>
                    {formIndikatorFaild &&
                    typeof formIndikatorFaild === "object" &&
                    formIndikatorFaild.meta ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formIndikatorFaild.meta.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Fuente de verificación
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      name="fuente_verificacion"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.fuente_verificacion}
                      placeholder="Fuente de verificación"
                      onChange={(e) => handleChange(e)}
                      isInvalid={
                        touched.fuente_verificacion &&
                        !!errors.fuente_verificacion
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.fuente_verificacion}
                    </Form.Control.Feedback>
                    {formIndikatorFaild &&
                    typeof formIndikatorFaild === "object" &&
                    formIndikatorFaild.fuente_verificacion ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formIndikatorFaild.fuente_verificacion.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Unidad de medida
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={loading ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          name="unidad_medida"
                          className="rounded-pill"
                          disabled={edit && loading}
                          required
                          value={values.unidad_medida}
                          isInvalid={
                            touched.unidad_medida && !!errors.unidad_medida
                          }
                          onChange={(e) => {
                            setFieldValue("unidad_medida", e.target.value);
                            handleUnitMeas(e.target.value);
                          }}
                        >
                          <option value="" disabled selected>
                            Unidad de medida
                          </option>
                          {measurementUnits
                            ? measurementUnits.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.id ? item.id : ""}
                                >
                                  {item.descripcion
                                    ? item.descripcion.toUpperCase()
                                    : ""}
                                </option>
                              ))
                            : null}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.unidad_medida}
                        </Form.Control.Feedback>
                        {formIndikatorFaild &&
                        typeof formIndikatorFaild === "object" &&
                        formIndikatorFaild.unidad_medida ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {formIndikatorFaild.unidad_medida.map((item) => (
                              <li>{item}</li>
                            ))}
                          </ul>
                        ) : null}
                      </Col>
                      {loaderMantIndks && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Abreviatura
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      className="rounded-pill"
                      required
                      readOnly
                      type="text"
                      defaultValue={unitMeasu ? unitMeasu.abreviatura : null}
                      placeholder="Abreviatura"
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Magnitud
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      className="rounded-pill"
                      required
                      readOnly
                      type="text"
                      defaultValue={unitMeasu ? unitMeasu.magnitud : null}
                      placeholder="Magnitud"
                    />
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowFormModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoaderIndikator}
                  variant="primary"
                  type="submit"
                >
                  {saveLoaderIndikator && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
};

export default Indkator;
